import i18n from "i18next";
import { IKonfigurationStParameter } from "../../Models/IKonfigurationStParameter";
import {
  createTableColumn,
  Text,
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
} from "@fluentui/react-components";

interface IConfiguratorStResultParameterProps {
  configurationParameter: IKonfigurationStParameter[];
}

function ConfiguratorStResultParameter(
  props: IConfiguratorStResultParameterProps,
) {
  const columns = [
    // ------------ Name -------------
    createTableColumn<IKonfigurationStParameter>({
      columnId: "nameId",
      renderHeaderCell: () => {
        return <Text>Name</Text>;
      },
      renderCell: (item) => {
        if (item.name) {
          return <Text>{i18n.t<string>(item.name)}</Text>;
        }
      },
    }),
    // ------------ wert -------------
    createTableColumn<IKonfigurationStParameter>({
      columnId: "wertId",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("wert")}</Text>;
      },
      renderCell: (item) => {
        return <Text>{i18n.t<string>(item.wert)}</Text>;
      },
    }),
  ];
  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        columns={columns}
        items={props.configurationParameter}
        resizableColumns
      >
        <DataGridHeader>
          <DataGridRow>
            {({ renderHeaderCell }) => (
              <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
            )}
          </DataGridRow>
        </DataGridHeader>
        <DataGridBody<IKonfigurationStParameter>>
          {({ item, rowId }) => (
            <DataGridRow<IKonfigurationStParameter> key={rowId}>
              {({ renderCell }) => (
                <DataGridCell>{renderCell(item)}</DataGridCell>
              )}
            </DataGridRow>
          )}
        </DataGridBody>
      </DataGrid>
    </div>
  );
}

export default ConfiguratorStResultParameter;
